import store from './plugins/store'

export const baseApiUrl = process.env.VUE_APP_BASE_API //
export const baseWaawUrl = 'https://integradorwaaw.azurewebsites.net' //

// export const baseWaawUrl = 'http://localhost:4013'
// export const baseApiUrl = 'http://localhost:4000' // 'https://345e-189-123-193-195.ngrok.io' //

export const userPayload = '_userPayload'

export function showError(e) {
  let text = ''
  console.log(e)
  if (e && e.response && e.response.data) {
    if (Array.isArray(e.response.data)) {
      e.response.data.forEach((element) => {
        text += element + '<br />'
      })
    } else {
      text = e.response.data.message
    }
  } else if (typeof e === 'string') {
    text = e
  } else {
    text = 'Algo deu errado.'
  }

  if (text) {
    store.dispatch('setErrorInfo', {
      open: true,
      text: text,
      button: 'Ok!',
    })
  }
}

export default { baseApiUrl, showError, userPayload }
